import { type TimeHTMLAttributes, useEffect, useState } from 'react';

import { BROWSER_LOCAL_TIME_ZONE, formatSiteDate } from '@/lib/time-zone';

type DateValue = string | number | Date;

type DateProps = Omit<TimeHTMLAttributes<HTMLTimeElement>, 'dateTime' | 'children'> & {
  value: DateValue;
};

type AccountTimeZoneDateProps = DateProps & {
  timeZone?: string | null;
};

type BrowserTimeZoneDateProps = DateProps & {
  fallbackTimeZone?: string | null;
};

function dateTimeValue(value: DateValue): string {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? String(value) : date.toISOString();
}

export function AccountTimeZoneDate({ value, timeZone, ...props }: AccountTimeZoneDateProps) {
  return (
    <time dateTime={dateTimeValue(value)} {...props}>
      {formatSiteDate(value, timeZone)}
    </time>
  );
}

export function BrowserTimeZoneDate({
  value,
  fallbackTimeZone,
  ...props
}: BrowserTimeZoneDateProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <time dateTime={dateTimeValue(value)} {...props}>
      {formatSiteDate(value, mounted ? BROWSER_LOCAL_TIME_ZONE : fallbackTimeZone)}
    </time>
  );
}
